import type { YandexSplitConfig } from '@/js/types/payment.ts';
import { makeApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function getYandexSplitConfig() {
  return makeRequest<YandexSplitConfig>({
    method: 'GET',
    url: makeApiRoute('payments/yandex-split/config'),
  });
}
